<div class="background">
    <div class="blob blob1"></div>
    <div class="blob blob2"></div>
    <div class="blob blob3"></div>
    <div class=" blob4"></div>
    <div class=" blob5"></div>
    <div class=" blob6"></div>
    <div class=" blob7"></div>
</div>

<div class="pageWrapper">
    <div class="headerWrapper row">
        <div class="headerContent col-md-12">
            <div style="text-align: center;">
                <h1 class="headerTag">A Prop-Tech Residential <span style="font-weight: 500;">Rental & Property Management</span> Company</h1>
                <h2 class="headerSubTag">Find perfect homes that understand you.</h2>
            </div>
            
        </div>
        <div class="col-md-6">
            <h1 class="headerTag"></h1>
        </div>
        <div class="headerCTA" style="width: 100%; margin-bottom: 40px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <ul class="nav nav-tabs header-tabs">
                <li class="nav-item">
                <p class="nav-link active" id="rent-tab" data-toggle="tab" data-target="#rent" >Rent</p>
                </li>
                <li class="nav-item">
                <a class="nav-link" id="property-tab" data-toggle="tab" data-target="#property">List Property</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent" style="width: 100%; display: flex; justify-content: center; align-items: center;">
                <div class="tab-pane fade show active" id="rent" role="tabpanel" aria-labelledby="rent-tab" style="width: 60%;">
                    <div class="tabContentWrapper">
                        <div style="margin-right: 16px;">
                            <select [ngModel]="(selectedCity)" (ngModelChange)="onSelectedCityChange($event)" title="city" class="city-dropdown">
                                <option *ngFor="let c of cityList" [ngValue]="c.id">{{c.text}}</option>
                            </select> 
                        </div>
                        <input  placeholder="Search any location, society or landmarks" class="location-input" [ngModel]="selectedLocation" (ngModelChange)="selectedLocation = $event" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search/>
                        <div class="CTABtn" (click)="searchProperty()">
                            <p style="color: #FFF;">Search</p>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="property" role="tabpanel" aria-labelledby="property-tab" style="width: 50%;">
                    <div class="tabContentWrapper">
                        <p class="tabContentText" >Rentals Made Easy - Post your property today!</p>
                        <div class="CTABtn">
                            <p style="color: #FFF;">Start listing</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="metricContainer row">
        <div class="col-md-3 metricContent">
            <p class="metricText">1M sq. ft.</p>
            <p class="metricLabel">Asset Under Maintenance</p>
        </div>
        <div class="col-md-3 metricContent">
            <p class="metricText">500+</p>
            <p class="metricLabel">Properties Managed</p>
        </div>
        <div class="col-md-3 metricContent">
            <p class="metricText">$10M</p>
            <p class="metricLabel">Order Book</p>
        </div>
        <div class="col-md-3 metricContent">
            <p class="metricText">Cities</p>
            <p class="metricLabel">Bengaluru, Pune</p>
        </div>
    </div>
    <div class="sectionWrapper">
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; row-gap: 12px;">
            <p class="sectionHeader" style="color: #828282;">Our</p>
            <p class="sectionHeader" style="font-weight: 600">Vision</p>
        </div>
        <div class="visionWrapper row">
            <div class="visionContent col-md-2" >
                <img src="assets/images/newhomepage/leftquote.png" class="quotesImg img-responsive"/>
            </div>
            <div class="visionContent col-md-8">
                <p class="visionText">Our vision at YourOwnROOM is to deliver higher economic returns to our Residential Real Estate Property Owners over the Property Lifecycle using our Prop-Tech based Residential Rental & Property Management Solutions.</p>
            </div>
            <div class="visionContent col-md-2">
                <img src="assets/images/newhomepage/rightquote.png" class="quotesImg img-responsive"/>
            </div>
        </div>
    </div>
    <div class="sectionSeparator"></div>



    
    <div class="homeContent">
        <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 40px 40px 0px 40px;">
            <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px;">
                <p class="sectionHeader" style="color: #828282;">Featured Properties for</p>
                <p *ngIf="selectedType === 1" class="sectionHeader" style="font-weight: 600; margin-top: 8px">Families</p>
                <p *ngIf="selectedType === 2" class="sectionHeader" style="font-weight: 600; margin-top: 8px">Coliving</p>
            </div>
            <div>
                <p (click)="toggleFeatureProperties(2)" class="sectionHeaderOption"  *ngIf="selectedType === 1">Show coliving properties</p>
                <p (click)="toggleFeatureProperties(1)" class="sectionHeaderOption"  *ngIf="selectedType === 2">Show family properties</p>
            </div>
        </div>
        <div class="horizontalDisplayItemsWrapper">
            <div *ngFor="let prop of featuredProperty" class="featuredPropertyItem " >
                <div *ngIf="prop.id != undefined || prop.id != null" style="height: 100%;">
                    <div  class="featuredPropImageWrapper" *ngIf=" prop.propimage !== null" [style.background-image]="'url(' + prop.propimage.url + ')'"></div>
                    <div  class="featuredPropImageWrapper noImage" *ngIf=" prop.propimage == null" >
                        <p class="noImageText">Images coming soon</p>
                    </div>
                    <div style="height: 132px; display: flex; justify-content: space-between; align-items: flex-start; flex-direction: column; width: 100%; flex-grow: 1;">
                        <div>
                            <p class="featuredPropName">{{prop.name}}</p>
                            <p class="featuredPropRent">{{prop.rent | currency:'INR':'symbol':'1.2-2' }}</p>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: flex-end; width: 100%;">
                            <p class="featuredPropName">{{prop.locality}}</p>
                            <div class="featuredPropBtn" [routerLink]="['/property',prop.id]">
                                <p class="moreBtn" >Explore</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding: 0px 40px">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 4rem; padding: 40px 0px 0px 0px;">
                <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px;">
                    <p class="sectionHeader" style="color: #828282;">Services for</p>
                    <p class="sectionHeader" style="font-weight: 600; margin-top: 8px">Home Owners</p>
                </div>
                
            </div>
            <div class="ownerSerivces">
                <div class="serviceContainer">
                    <div style="display: flex; justify-content: space-between; column-gap: 8px; width: 100%;">
                        <p class="serviceText">Residential Rental Management</p>
                        <fa-icon [icon]="arrowRight" size="16" ></fa-icon>
                    </div>
                    <p class="serviceSubText">Unlock your property's full value with personalized, expert management solutions.</p>
                </div>
                <div class="serviceContainer">
                    <div style="display: flex; justify-content: space-between; column-gap: 8px; width: 100%;">
                        <p class="serviceText">Property Management Services</p>
                        <fa-icon [icon]="arrowRight" size="16" ></fa-icon>
                    </div>
                    <p class="serviceSubText">Optimize your property's performance with our specialized, hands-on management expertise</p>
                </div>
            </div>
        </div>
        <div style=" padding: 40px;">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 4rem;">
                <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px;">
                    <p class="sectionHeader" style="color: #828282;">Strategic</p>
                    <p class="sectionHeader" style="font-weight: 600; margin-top: 8px">Partnerships</p>
                </div>
            </div>
            <div class="partnerships">
                <div class="partnershipContainer">
                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;" [routerLink]="['/partnerships/fiverings']">
                        <p class="partnershipName">EXD Five Rings</p>
                        <img src="assets/images/exd.png" class="partnershipImage img-responsive">
                    </div>
                    <p class="serviceSubText">YourOwnROOM and EXD Five Rings collaborate to offer compelling financial real estate products.</p>
                    <div class="absoluteArrow">
                        <fa-icon [icon]="arrowRight" size="16" ></fa-icon>
                    </div>
                </div>
                <div class="partnershipContainer">
                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;" [routerLink]="['/partnerships/ygc']">
                        <p class="partnershipName">Your Green Canvas</p>
                        <img src="assets/images/ygc.png" class="partnershipImage img-responsive">
                    </div>
                    <p class="serviceSubText">YourOwnROOM collaborates with YGC to offer property management solutions and projects.</p>
                    <div class="absoluteArrow">
                        <fa-icon [icon]="arrowRight" size="16" ></fa-icon>
                    </div>
                </div>
                <div class="partnershipContainer">
                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;" [routerLink]="['/partnerships/eqaro']">
                        <p class="partnershipName">EQARO Guarantees</p>
                        <img src="assets/images/eqaro.png" class="partnershipImage img-responsive">
                    </div>
                    <p class="serviceSubText">YourOwnROOM joins hands with Eqaro to offer Rental Bonds.</p>
                    <div class="absoluteArrow">
                        <fa-icon [icon]="arrowRight" size="16" ></fa-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="testimonials">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 4rem; padding: 40px;">
                <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px;">
                    <p *ngIf="selectedTestimonialType === 1" class="sectionHeader">Tenant</p>
                    <p *ngIf="selectedTestimonialType === 2" class="sectionHeader">Home Owner</p>
                    <p class="sectionHeader" style="font-weight: 600;margin-top: 8px">Testimonials</p>
                </div>
                <div>
                    <p (click)="toggleTestimonials(2)" class="sectionHeaderOption"  *ngIf="selectedTestimonialType === 1">Home owner testimonials</p>
                    <p (click)="toggleTestimonials(1)" class="sectionHeaderOption"  *ngIf="selectedTestimonialType === 2">Tenant testimonials</p>
                </div>
            </div>
            <div class="testimony_container">
                <div class="testimonial_wrapper" id="testimony_carousal" *ngIf="selectedTestimonialType === 1">
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/XruQHJlbJO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/IUiC2tIKkzc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/9NpI2l7Z_Dk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/0aJg1pghuf0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
                <div class="testimonial_wrapper" id="testimony_carousal" *ngIf="selectedTestimonialType === 2">
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/ANprt_nTEak" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/dJFALaEPe9A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/tQfMioGKlhg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/uiUy8nFhPJE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/rEt9myoQf-0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                    <div class="col-lg-4 testimonial_card_video">
                        <div class="testimonial-video-wrapper" >
                            <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/6by-yUsUKNU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="testimonials">
            <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 4rem; padding: 40px;">
                <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px;">
                    <p class="sectionHeader" style="color: #828282;">In the</p>
                    <p class="sectionHeader" style="font-weight: 600;margin-top: 8px">News</p>
                </div>
            </div>
            <div class="testimony_container">
                <div class="yor_news" id="news_carousal">
                    <div class="news col-12 col-lg-3 col-md-4">
                        <a href="https://startupstorymedia.com/startuptv/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/" target="_blank">
                            <img src="assets/images/news/startup-story.png" alt="YourOwnROOM News" style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-md-4">
                        <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling/" target="_blank">
                            <img src="assets/images/news/news_yourstory.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">
                            <img src="assets/images/news/news_full-Disrupt-logo.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">
                            <img src="assets/images/news/news_deccan.jpeg" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://thetechpanda.com/2017/10/04/startup-millennials-apartments/" target="_blank">
                            <img src="assets/images/news/news_TheTechPanda.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">
                            <img src="assets/images/news/news_siliconindia.gif" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://www.indianweb2.com/search?q=yourownroom" target="_blank">
                            <img src="assets/images/news/news_indianweb2.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://m.dailyhunt.in/news/india/english/yourstory-epaper-yourstory/amid+coronavirus+how+proptech+rental+yourownroom+is+handling+tenants+and+scaling+up+its+platform-newsid-n177954266" target="_blank">
                            <img src="assets/images/news/news_dailyhunt.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://www.onlinemarketplaces.com/?s=yourownroom" target="_blank">
                            <img src="assets/images/news/news_propertyportal.png" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://epaper.prabhatkhabar.com/c/10229063" target="_blank">
                            <img src="assets/images/news/news_prabhatkhabar.jpg" alt="YourOwnROOM News"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://www.bangaloreinsider.com/yourownroom/" target="_blank">
                            <img src="assets/images/news/bangalore-insider.png"  style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="http://www.thenewsminute.com/article/new-breed-startups-wants-solve-problems-house-renters-65949" target="_blank">
                            <img src="assets/images/news/news_thenewsmnt.jpg"   style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://www.bitosaglobal.org/news/14654" target="_blank">
                            <img src="assets/images/news/bitosa_logo.png"   style="width: 140px;">
                        </a>
                    </div>
                    <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                        <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank">
                            <img src="assets/images/news/Paulwriter.png"  style="width: 140px;">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
    
</div>
